<template>
  <div class="developer-tree-node">
    <router-link
      active-class="active"
      :to="developerRoute(node.developer.id)"
      :title="node.developer.departmentsForTitle"
    >
      <v-icon
        class="nv_icon mr-1"
        v-if="node.developer.status === false"
        x-small
      />
      {{ node.developer.transName }}
    </router-link>

    <div v-if="hasChildren">
      <a
        class="show-child-developer child-toggle-link"
        v-show="!isExpanded"
        @click="isExpanded = true"
      >
        {{ $t('Показать') }} ({{ descendantsCount }})
      </a>
      <a
        class="hide-child-developer child-toggle-link"
        v-show="isExpanded"
        @click="isExpanded = false"
      >
        {{ $t('Скрыть') }} ({{ descendantsCount }})
      </a>

      <div v-show="isExpanded" class="dev-children">
        <span
          v-for="child in node.children"
          :key="child.developer.id"
          class="developer-tree-child"
        >
          <developer-tree-node :node="child" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeveloperTreeNode',
  props: {
    node: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isExpanded: false
  }),
  computed: {
    hasChildren() {
      return Array.isArray(this.node.children) && this.node.children.length > 0
    },
    descendantsCount() {
      return this.countDescendants(this.node.children || [])
    }
  },
  methods: {
    developerRoute(id) {
      return this.$i18nRoute({
        name: 'search-npa',
        query: { developer: id }
      })
    },
    countDescendants(children) {
      let count = 0
      children.forEach((child) => {
        count += 1
        if (Array.isArray(child.children) && child.children.length > 0) {
          count += this.countDescendants(child.children)
        }
      })

      return count
    }
  }
}
</script>
